<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/gwc40f/cover.jpeg?1684305979367" alt="This image is the cover for the book Discarded Imperial Beauty, Volume 1"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Discarded Imperial Beauty, Volume 1
      </h1>
      <p class="bookDescription body article font2">
        <p><strong>The bustling hall was filled with the colors of celebration as the joyous official sang loudly amidst the hubbub, "I bow to the heavens and earth!"</strong></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Na LanJingYu, Lemon Novel
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Funstory
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8a2c94fe